/* 🤖 this file was generated by svg-to-ts */
export const matIconHPlusMobiledata: {
  name: 'h-plus-mobiledata';
  data: string;
} = {
  name: 'h-plus-mobiledata',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"/></svg>`
};
